<template>
	<b-modal class="modal-content" ref="mdlGestioneAttivitaAttivitaListSelectModal" size="xl" :title="title" scrollable no-close-on-backdrop no-close-on-select ok-title="Associa" @shown="onShownMdlGestioneAttivitaAttivitaListSelectModal" @ok="oOkMdlGestioneAttivitaAttivitaListSelectModal">
		<gestione-attivita-progetti-list-component :selectable="true" ref="cmpGestioneAttivitaProgettiListComponent"></gestione-attivita-progetti-list-component>
	</b-modal>
</template>

<script>
import GestioneAttivitaProgettiListComponent from "./GestioneAttivitaProgettiListComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: { GestioneAttivitaProgettiListComponent },
	data() {
		return {
			title: "Modal",
			tipo: null,
			idAttivita: null,
			pathResource: "/gestioneattivitaassetattivita",
			numeroRecords: 0,
			numeroRecordsSalvati: 0,
			allSavedSuccess: true,
		};
	},
	methods: {
		show(title, tipo, idAttivita) {
			let me = this;
			me.title = title;
			me.tipo = tipo;
			me.idAttivita = idAttivita;
			me.$refs.mdlGestioneAttivitaAttivitaListSelectModal.show();
		},
		onShownMdlGestioneAttivitaAttivitaListSelectModal() {
			let me = this;
			me.$refs.cmpGestioneAttivitaProgettiListComponent.init({ tipo: me.tipo });
		},
		oOkMdlGestioneAttivitaAttivitaListSelectModal(bvModalEvent) {
			let me = this;
			bvModalEvent.preventDefault();
			let selectionRows = this.$refs.cmpGestioneAttivitaProgettiListComponent.getSelectionRows();
			me.numeroRecords = selectionRows.length;
			selectionRows.forEach((element) => {
				me.associaAsset(element.id);
			});
		},
		associaAsset(idAsset) {
			let me = this;
			let body = { idAttivita: me.idAttivita, idAsset: idAsset };
			me.saveResource(me.pathResource, body, me.associaAssetSuccess, me.associaAssetError);
		},
		associaAssetSuccess() {
			let me = this;
			this.numeroRecordsSalvati++;
			me.$bvToast.toast("Associazione avvenuta con succedsso ", {
				title: "Elemento Associato",
				variant: "success",
				solid: true,
			});
			me.$emit("associzioneAvvenuta");
			me.closeModal();
		},
		associaAssetError(error) {
			let me = this;
			this.numeroRecordsSalvati++;
			me.allSavedSuccess = false;
			me.$bvToast.toast("Errore nel salvataggio" + error.message, {
				title: "Errore",
				variant: "danger",
				solid: true,
			});
			me.closeModal();
		},
		closeModal() {
			if (this.numeroRecordsSalvati === this.numeroRecords && this.allSavedSuccess) {
				this.$refs.mdlGestioneAttivitaAttivitaListSelectModal.hide();
			}
		},
	},
};
</script>

<style></style>
